import { SET_IS_AUTH, SET_AUTH } from '../constants';

const setIsAuth = state => ({ type: SET_IS_AUTH, payload: state });
const setAuth = state => ({ type: SET_AUTH, payload: state });

const auth = { setIsAuth, setAuth };

export default auth;